/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Csv_Import_SubmitInputs */



/**
* | output |
* | --- |
* | "Register {count} player(s)" |
*
* @param {Csv_Import_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_submit = /** @type {((inputs: Csv_Import_SubmitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_SubmitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Inscrire ${i?.count} joueur(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Inscribir ${i?.count} jugador/es`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Inscrever ${i?.count} jogador/es`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Iscrivi ${i?.count} giocatore/i`)
	return /** @type {LocalizedString} */ (`Register ${i?.count} player(s)`)
});